// extracted by mini-css-extract-plugin
export default {"TVChartContainerWrapper":"styles_TVChartContainerWrapper__GBrUn","TVChartContainer":"styles_TVChartContainer__5FFnW","noHeader":"styles_noHeader__eUAfe"};